module.exports = __webpack_public_path__ + "media/images/icons/since-badge-nl-13dc0b58f16e117b95cd0f26f811de3c.svg";